import {
  button_grid_styles_default
} from "./chunk.WFHD2O7V.js";
import {
  getResponsiveNumber
} from "./chunk.JI3RRLCG.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/button-grid/button-grid.ts
var FadvButtonGrid = class extends s {
  constructor() {
    super(...arguments);
    this.label = "";
    this.pill = false;
    this.outline = false;
    this.columns = 3;
    this.columnGap = 12;
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleResize = this.handleResize.bind(this);
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(document.body);
  }
  firstUpdated() {
    this.handleResize();
  }
  handleColumnsChange() {
    var _a;
    this.columnsState = (_a = getResponsiveNumber(this.columns)) != null ? _a : 3;
  }
  handleColumnGapChange() {
    var _a;
    this.columnGapState = (_a = getResponsiveNumber(this.columnGap)) != null ? _a : 12;
  }
  handleResize() {
    this.handleColumnsChange();
    this.handleColumnGapChange();
  }
  handleSlotChange() {
    const buttons = this.defaultSlot.assignedElements({ flatten: true }).filter((e2) => hasTag(e2, "fadv-button") || hasTag(e2, "fadv-radio-button")).map((e2) => e2);
    buttons.forEach((b) => {
      var _a, _b;
      b.variant = (_a = this.variant) != null ? _a : b.variant;
      b.size = (_b = this.size) != null ? _b : b.size;
      b.pill = this.pill || b.pill;
      b.outline = this.outline || b.outline;
      b.classList.add("fadv-button-grid__button");
    });
  }
  render() {
    return $`<div class="button-grid" aria-label=${this.label} style="--columns:${this.columnsState}; --gap:${this.columnGapState}px;"><slot @slotchange=${this.handleSlotChange}></slot></div>`;
  }
};
FadvButtonGrid.styles = button_grid_styles_default;
__decorateClass([
  e()
], FadvButtonGrid.prototype, "label", 2);
__decorateClass([
  e({ reflect: true })
], FadvButtonGrid.prototype, "variant", 2);
__decorateClass([
  e({ reflect: true })
], FadvButtonGrid.prototype, "size", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvButtonGrid.prototype, "pill", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvButtonGrid.prototype, "outline", 2);
__decorateClass([
  e({ type: Object })
], FadvButtonGrid.prototype, "columns", 2);
__decorateClass([
  e({ type: Object })
], FadvButtonGrid.prototype, "columnGap", 2);
__decorateClass([
  i("slot")
], FadvButtonGrid.prototype, "defaultSlot", 2);
__decorateClass([
  t()
], FadvButtonGrid.prototype, "columnsState", 2);
__decorateClass([
  t()
], FadvButtonGrid.prototype, "columnGapState", 2);
__decorateClass([
  watch("columns")
], FadvButtonGrid.prototype, "handleColumnsChange", 1);
__decorateClass([
  watch("columnGap")
], FadvButtonGrid.prototype, "handleColumnGapChange", 1);
__decorateClass([
  watch("variant", { waitUntilFirstUpdate: true }),
  watch("size", { waitUntilFirstUpdate: true }),
  watch("pill", { waitUntilFirstUpdate: true }),
  watch("outline", { waitUntilFirstUpdate: true })
], FadvButtonGrid.prototype, "handleSlotChange", 1);
FadvButtonGrid = __decorateClass([
  n("fadv-button-grid")
], FadvButtonGrid);

export {
  FadvButtonGrid
};
